<template>
    <div id="app">
        <div class="ddc-image-holder">
            <signup v-if="mainPage == 1" />
            <timeoutpage v-if="mainPage == 2" />
        </div>
    </div>
</template>

<script>
import Signup from "./components/Signup";
import Timeoutpage from "./components/TimeoutPage";

export default {
    name: "app",
    props: ["product", "billFreq"],
    components: {
        Signup,
        Timeoutpage
    },
    computed: {
        mainPage() {
            return this.$store.state.mainPage;
        }
    },
    created() {
        // console.log("Main, create hook  bv181210");
        // console.log("  Props product is " + this.product + "  (inbound product code passed from referring site)");
        // console.log(JSON.stringify(this.$route));
        // console.log(this.$route);
        // Check for product request from query -> passed to props
        let planNum;
        let qProduct = String(this.product || "").toLowerCase();
        // if (qProduct === "free") {
        //     planNum = 1;
        // } else
        if (qProduct === "solo") {
            planNum = 2;
        } else {
            planNum = 3;
        }
        this.$store.dispatch("choosePlan", planNum);
        if (this.billFreq === "A" || this.billFreq === "M") {
            this.$store.dispatch("changeBillFreq", this.billFreq);
        } else {
            // Start with default of ANNUAL for now (Nov 2022 re: BF coupons, Dean/Jaime want this...)
            this.$store.dispatch("changeBillFreq", 'A');
        }
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}

.ddc-image-holder {
    padding: 20px;
    height: 100vh;
    background-image: url("https://s3.amazonaws.com/designdocs-public-assets/sub-bg.png");
    background-attachment: scroll;
    background-clip: border-box;
    background-origin: padding-box;
    background-position: 50% 50%;
    background-position-x: 50%;
    background-position-y: 50%;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/App.vue